module.exports = __webpack_public_path__ + "static/img/noimg.8f26025a.png";